/* ============================================================
   Home page funnel — reskin helper.
   On the home page only, every link is redirected to the bundle
   builder, EXCEPT:
     • anything inside the footer group (#site-footer-group)
     • cart / search / account / checkout utility actions
     • the cart drawer & predictive search (kept functional)
   Loaded only on template-index from layout/theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  var BUNDLE_URL = '/pages/bundle';

  // Containers whose links must keep their real destinations.
  var KEEP_CONTAINERS =
    '#site-footer-group, cart-drawer, #CartDrawer, .cart-drawer, ' +
    '#cart-notification, .cart-notification, predictive-search, ' +
    '#predictive-search, .header-actions';

  function shouldSkip(a) {
    if (a.closest(KEEP_CONTAINERS)) return true;

    var href = (a.getAttribute('href') || '').toLowerCase();
    if (!href) return true;
    // Keep utility / commerce links working.
    if (/^\/(cart|account|search|checkout)(\/|$|\?|#)/.test(href)) return true;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return true;

    return false;
  }

  function rewrite() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (shouldSkip(a)) continue;
      a.setAttribute('href', BUNDLE_URL);
      a.removeAttribute('target');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewrite);
  } else {
    rewrite();
  }
})();
